import { useMutation } from "@apollo/client";
import React from "react";
import { useNavigate } from "react-router-dom";
import { SCREENS } from "utils/constants";
import View from "./View";
import graphql from "utils/api/graphql";

const Create = () => {
  const navigate = useNavigate();
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.FEEDS.LIST);
  const [createFeed] = useMutation(graphql.mutations.CREATE_FEED, {
    onCompleted: () => {
      navigate(SCREENS.PRIVATE.ADMIN.FEEDS.LIST);
    },
    onError: () => {},
  });
  const onSubmit = (values) => {
    return createFeed({
      variables: {
        data: {
          ...values,
        },
      },
    });
  };
  return <View onSubmit={onSubmit} cancel={cancel} />;
};

export default Create;
